import { faAnglesDown, faAnglesLeft, faAnglesRight, faAnglesUp } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Helmet } from "react-helmet";
import './../../../cartooned.css';
import goldRibon from './../../../assets/image/gold_ribon.png'
import silverRibon from './../../../assets/image/silver_ribon.png'
import bronzeRibon from './../../../assets/image/bronze_ribon.png';
import ProgressBar from "./ProgressBar";
import { useEffect, useRef, useState } from "react";
import blankProfile from './../../../assets/image/blankProfile.webp';

interface recruitersPrevProps {
    recruiters : string;
    recruiters_dp : string;
    color : string;
    rev_percentage : number;
}

interface clientServicesProps {
    client : string;
    progress_bar_color : string;
    revenue_precentage : number;
    recruiters_rev : recruitersPrevProps[];
}

const clientServicesData: clientServicesProps[] = [
    {
      client: "ABC Company",
      progress_bar_color: "#FFD700", // Gold
      revenue_precentage: 80,
      recruiters_rev: [
        { recruiters: "Recruiter 1", recruiters_dp: "", color: "#CD7F32", rev_percentage: 45 },
        { recruiters: "Recruiter 2", recruiters_dp: "", color: "#C0C0C0", rev_percentage: 35 },
      ],
    },
    {
      client: "XYZ Corp",
      progress_bar_color: "#4F46E5", // Indigo
      revenue_precentage: 65,
      recruiters_rev: [
        { recruiters: "Recruiter 3", recruiters_dp: "", color: "#FFD700", rev_percentage: 40 },
        { recruiters: "Recruiter 4", recruiters_dp: "", color: "#10B981", rev_percentage: 25 },
      ],
    },
    {
      client: "Global Solutions",
      progress_bar_color: "#EF4444", // Red
      revenue_precentage: 70,
      recruiters_rev: [
        { recruiters: "Recruiter 5", recruiters_dp: "", color: "#3B82F6", rev_percentage: 38 },
        { recruiters: "Recruiter 6", recruiters_dp: "", color: "#8B5CF6", rev_percentage: 32 },
      ],
    },
    {
      client: "Delta Group",
      progress_bar_color: "#22C55E", // Green
      revenue_precentage: 75,
      recruiters_rev: [
        { recruiters: "Recruiter 7", recruiters_dp: "", color: "#A855F7", rev_percentage: 50 },
        { recruiters: "Recruiter 8", recruiters_dp: "", color: "#EAB308", rev_percentage: 25 },
      ],
    },
    {
      client: "OmniTech",
      progress_bar_color: "#06B6D4", // Cyan
      revenue_precentage: 60,
      recruiters_rev: [
        { recruiters: "Recruiter 9", recruiters_dp: "", color: "#F97316", rev_percentage: 30 },
        { recruiters: "Recruiter 10", recruiters_dp: "", color: "#14B8A6", rev_percentage: 30 },
      ],
    },
    {
      client: "Alpha Systems",
      progress_bar_color: "#3B82F6", // Blue
      revenue_precentage: 68,
      recruiters_rev: [
        { recruiters: "Recruiter 11", recruiters_dp: "", color: "#E879F9", rev_percentage: 40 },
        { recruiters: "Recruiter 12", recruiters_dp: "", color: "#FACC15", rev_percentage: 28 },
      ],
    },
    {
      client: "BetaTech",
      progress_bar_color: "#F59E0B", // Amber
      revenue_precentage: 72,
      recruiters_rev: [
        { recruiters: "Recruiter 13", recruiters_dp: "", color: "#60A5FA", rev_percentage: 38 },
        { recruiters: "Recruiter 14", recruiters_dp: "", color: "#34D399", rev_percentage: 34 },
      ],
    },
    {
      client: "CoreVision",
      progress_bar_color: "#8B5CF6", // Violet
      revenue_precentage: 66,
      recruiters_rev: [
        { recruiters: "Recruiter 15", recruiters_dp: "", color: "#C084FC", rev_percentage: 28 },
        { recruiters: "Recruiter 16", recruiters_dp: "", color: "#A3E635", rev_percentage: 30 },
      ],
    },
    {
      client: "NextGen Co.",
      progress_bar_color: "#D946EF", // Fuchsia
      revenue_precentage: 74,
      recruiters_rev: [
        { recruiters: "Recruiter 17", recruiters_dp: "", color: "#F472B6", rev_percentage: 36 },
        { recruiters: "Recruiter 18", recruiters_dp: "", color: "#FB923C", rev_percentage: 30 },
      ],
    },
    {
      client: "VantageWorks",
      progress_bar_color: "#10B981", // Emerald
      revenue_precentage: 69,
      recruiters_rev: [
        { recruiters: "Recruiter 19", recruiters_dp: "", color: "#38BDF8", rev_percentage: 33 },
        { recruiters: "Recruiter 20", recruiters_dp: "", color: "#6366F1", rev_percentage: 36 },
      ],
    },
  ];
  

const CstDashboard = () => {
    const [goldData, setGoldData] = useState<clientServicesProps[] | null>(clientServicesData);
    const [goldCount, setGoldCount] = useState<number>(5);
    const [silverData, setSilverData] = useState<clientServicesProps[] | null>(clientServicesData);
    const [silverCount, setSilverCount] = useState<number>(5);
    const [bronzeData, setBronzeData] = useState<clientServicesProps[] | null>(clientServicesData);
    const [bronzeCount, setBronzeCount] = useState<number>(5);
    const [showSideModal, setShowSideModal] = useState<boolean>(true);
    const modal = useRef<HTMLDivElement | null>(null)

    const handleShowMoreGold = () => setGoldCount(goldCount + 3);
    const handleShowLessGold = () => setGoldCount(5);

    const handleShowMoreSilver = () => setSilverCount(silverCount + 3);
    const handleShowLessSilver = () => setSilverCount(5);

    const handleShowMoreBronze = () => setBronzeCount(bronzeCount + 3);
    const handleShowLessBronze = () => setBronzeCount(5);

    const handleShowSideModal = () => setShowSideModal(true);

    const handleHideSideModal = () => setShowSideModal(false);

    // const getRandomColor = () => {
    //     const letters = '0123456789ABCDEF';
    //     let color = '#';
    //     for (let i = 0; i < 6; i++) {
    //       color += letters[Math.floor(Math.random() * 16)];
    //     }
    //     return color;
    // };

    return(
        <div className="content overflow-x-hidden overflow-y-hidden bg-gray-600 caveat-brush-regular">
             <Helmet>
                <title>CST Dashboard</title>
            </Helmet>
            <div className="flex h-full">
                <div className={`${showSideModal ? 'w-[calc(100%-500px)]' : 'w-full'} transition-all duration-300`}>
                    <div className="bg-gray-200 p-2 text-gray-600 min-h-16 flex gap-4 items-center shadow-xl">
                        <div className="w-full">
                            <h1>CST Dashboard</h1>
                        </div>
                        <div className="ms-auto w-48">
                            <button type="button" className="cartooned-button-light">
                                View monthly
                            </button>
                        </div>
                        <div className="ms-auto me-4">
                            {!showSideModal && (
                                <button type="button" onClick={handleShowSideModal} className="hover:text-lg hover:text-orange-400 active:text-gray-700 active:text-sm">
                                    <FontAwesomeIcon icon={faAnglesLeft} />
                                </button>
                            )}
                            
                        </div>
                    </div>
                    {/* main container */}
                    <div className="overflow-y-auto hide-scrollbar h-full pb-24 bg-gray-600">
                        <div className="text-center my-6 w-full flex items-center justify-center">
                            <h1 className="text-5xl font-semibold text-orange-400 animate-bounce">
                                WELCOME LINKERS!
                            </h1>
                        </div>
                        {/* card container */}
                        <div className={`flex transition-all duration-700 ${showSideModal ? 'flex-col mx-24 gap-12' : 'flex-row mx-4 gap-2'}`}>

                            <div className="w-full">
                                <div className="cartooned-card">
                                    <div className="flex gap-2 items-center text-4xl">
                                        <img src={goldRibon} className='w-8' alt=""/>
                                        <h2>Gold</h2>
                                    </div>
                                    <div className="flex flex-col gap-2 my-3">
                                        {goldData && goldData.slice(0, goldCount).map(gold => (
                                            <div className="group bg-gray-700 px-2 py-2 rounded cursor-pointer hover:border border-yellow-400">
                                                <div className="flex items-center readable-caveat">
                                                    <div>
                                                        <h3>{gold.client}</h3>
                                                    </div>
                                                    <div className="ms-auto mr-6">
                                                        {gold.revenue_precentage}%
                                                    </div>
                                                </div>
                                                <div>
                                                    <ProgressBar progress={gold.revenue_precentage} hex_color={'#FFD700'} />
                                                </div>
                                                <div className="flex mt-1 relative">
                                                    {gold.recruiters_rev.map(rec => (
                                                        <div
                                                            className="h-8 flex gap-4 items-center rounded-full transition-all border-2 border-white duration-300 text-center cursor-pointer"
                                                            style={{ width: `${rec.rev_percentage}%`, backgroundColor : rec.color}}
                                                        >
                                                            <div>
                                                                <img src={blankProfile} className='cartooned-img' alt="userProfile" />
                                                            </div>
                                                            <div className="bg-gray-700 px-4 hidden group-hover:block rounded-xl">
                                                                <p>{rec.recruiters}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="text-right px-2">
                                        {goldData && goldCount >= goldData.length ? (
                                            <button type="button" onClick={handleShowLessGold} className="cartooned-button">
                                                <FontAwesomeIcon icon={faAnglesUp} /> &nbsp;
                                                view less
                                            </button>
                                        ) : (
                                            <button type="button" onClick={handleShowMoreGold} className="cartooned-button">
                                                <FontAwesomeIcon icon={faAnglesDown} /> &nbsp;
                                                view more
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>


                            <div className="w-full">
                                <div className="cartooned-card">
                                    <div className="flex gap-2 items-center text-4xl">
                                        <img src={silverRibon} className='w-8' alt=""/>
                                        <h2>Silver</h2>
                                    </div>
                                    
                                    <div className="flex flex-col gap-2 my-3">
                                        {silverData && silverData.slice(0, silverCount).map(silver => (
                                            <div className="group bg-gray-700 px-2 py-2 rounded cursor-pointer hover:border border-gray-400">
                                                <div className="flex items-center readable-caveat">
                                                    <div>
                                                        <h3>{silver.client}</h3>
                                                    </div>
                                                    <div className="ms-auto mr-6">
                                                        {silver.revenue_precentage}%
                                                    </div>
                                                </div>
                                                <div>
                                                    <ProgressBar progress={silver.revenue_precentage} hex_color={'#C0C0C0'} />
                                                </div>
                                                <div className="flex mt-1 relative">
                                                    {silver.recruiters_rev.map(rec => (
                                                        <div
                                                            className="h-8 flex gap-4 items-center rounded-full transition-all border-2 border-white duration-300 cursor-pointer"
                                                            style={{ width: `${rec.rev_percentage}%`, backgroundColor : rec.color}}
                                                        >
                                                            <div>
                                                                <img src={blankProfile} className='cartooned-img' alt="userProfile" />
                                                            </div>
                                                            <div className="bg-gray-700 px-4 hidden group-hover:block rounded-xl">
                                                                <p>{rec.recruiters}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="text-right px-2">
                                        {silverData && silverCount >= silverData.length ? (
                                            <button type="button" onClick={handleShowLessSilver} className="cartooned-button">
                                                <FontAwesomeIcon icon={faAnglesUp} /> &nbsp;
                                                view less
                                            </button>
                                        ) : (
                                            <button type="button" onClick={handleShowMoreSilver} className="cartooned-button">
                                                <FontAwesomeIcon icon={faAnglesDown} /> &nbsp;
                                                view more
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                            
                            <div className="w-full">
                                <div className="cartooned-card">
                                    <div className="flex gap-2 items-center text-4xl">
                                        <img src={bronzeRibon} className='w-8' alt=""/>
                                        <h2>Bronze</h2>
                                    </div>
                                    
                                    <div className="flex flex-col gap-2 my-3">
                                        {bronzeData && bronzeData.slice(0, bronzeCount).map(bronze => (
                                            <div className="group bg-gray-700 px-2 py-2 rounded cursor-pointer hover:border border-orange-700">
                                                <div className="flex items-center readable-caveat">
                                                    <div>
                                                        <h3>{bronze.client}</h3>

                                                    </div>
                                                    <div className="ms-auto mr-6">
                                                        {bronze.revenue_precentage}%
                                                    </div>
                                                </div>
                                                <div>
                                                    <ProgressBar progress={bronze.revenue_precentage} hex_color={'#CD7F32'} />
                                                </div>
                                                <div className="flex mt-1 relative">
                                                    {bronze.recruiters_rev.map(rec => (
                                                        <div
                                                            className="h-8 flex gap-4 items-center rounded-full transition-all border-2 border-white duration-300 cursor-pointer"
                                                            style={{ width: `${rec.rev_percentage}%`, backgroundColor : rec.color}}
                                                        >
                                                            <div>
                                                                <img src={blankProfile} className='cartooned-img' alt="userProfile" />
                                                            </div>
                                                            <div className="bg-gray-700 px-4 hidden group-hover:block rounded-xl">
                                                                <p>{rec.recruiters}</p>
                                                            </div>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                    <div className="text-right px-2">
                                        {bronzeData && bronzeCount >= bronzeData.length ? (
                                            <button type="button" onClick={handleShowLessBronze} className="cartooned-button">
                                                <FontAwesomeIcon icon={faAnglesUp} /> &nbsp;
                                                view less
                                            </button>
                                        ) : (
                                            <button type="button" onClick={handleShowMoreBronze} className="cartooned-button">
                                                <FontAwesomeIcon icon={faAnglesDown} /> &nbsp;
                                                view more
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>

                        </div>
                        {/* end card container */}
                    </div>
                </div>

                {/* Side Modal */}
                <div ref={modal} className={`bg-gray-800 text-gray-700 h-full top-0 right-0 w-[500px] fixed transition-transform duration-300 z-50 ${
                    showSideModal ? 'translate-x-0' : 'translate-x-full'
                }`}>
                    <div className="bg-gray-200 p-2 text-gray-600 min-h-16 flex items-center shadow-xl">
                        <div>
                            <button type="button" onClick={handleHideSideModal} className="hover:text-orange-400 active:text-gray-700 active:text-sm">
                                <FontAwesomeIcon icon={faAnglesRight} />
                            </button>
                        </div>
                        <div className="w-full text-center">
                            <h1 className="text-xl">Recruiters list</h1>
                        </div>
                    </div>
                    <div className="flex flex-col gap-4 my-8 mx-6 items-center text-gray-300 h-full">
                        <div className="flex p-2 gap-4 bg-gray-700 w-full px-4 h-16 rounded">
                            <div>
                                <img src={blankProfile} className='account-img' alt="userProfile" />
                            </div>
                            <div className="readable-caveat">
                                <div>
                                    <h2>Recruiter's name</h2>
                                </div>
                                <div>
                                    <p className="text-sm">Position Title</p>
                                </div>
                            </div>
                            <div className="ms-auto">
                                <div className="bg-[#ef5d2e] w-12 h-12 rounded-3xl"></div>
                            </div>
                        </div>

                        <div className="flex p-2 gap-4 bg-gray-700 w-full px-4 h-16 rounded">
                            <div>
                                <img src={blankProfile} className='account-img' alt="userProfile" />
                            </div>
                            <div className="readable-caveat">
                                <div>
                                    <h2>Recruiter's name</h2>
                                </div>
                                <div>
                                    <p className="text-sm">Position Title</p>
                                </div>
                            </div>
                            <div className="ms-auto">
                                <div className="bg-[#3a57c0] w-12 h-12 rounded-3xl"></div>
                            </div>
                        </div>

                        <div className="flex p-2 gap-4 bg-gray-700 w-full px-4 h-16 rounded">
                            <div>
                                <img src={blankProfile} className='account-img' alt="userProfile" />
                            </div>
                            <div className="readable-caveat">
                                <div>
                                    <h2>Recruiter's name</h2>
                                </div>
                                <div>
                                    <p className="text-sm">Position Title</p>
                                </div>
                            </div>
                            <div className="ms-auto">
                                <div className="bg-[#41ef2e] w-12 h-12 rounded-3xl"></div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End of side modal */}
            </div>


        </div>
    );
}

export default CstDashboard;